export const PAGE_TITLES = {
    HOME: {
        tracking: "Homepage - EmploSkills Virtual Business Challenge",
        seo: "EmploSkills - Master Business Skills Through Real-World Simulation"
    },
    BUSINESS_CHALLENGE: {
        tracking: "Business Challenge Details Page",
        seo: "Virtual Business Challenge for Homeschoolers | EmploSkills"
    },
    BLOG: {
        tracking: "Blog Overview Page",
        seo: "EmploSkills Blog - Business Education Insights & Tips"
    },
    BLOG_POST: {
        tracking: "Blog Post View",
        seo: "EmploSkills Blog - {title}"
    },
    ORDER: {
        tracking: "Order Business Challenge Page",
        seo: "Order Business Challenge - EmploSkills"
    },
    FB_LANDING: {
        seo: 'Join the Virtual Business Challenge - EmploSkills',
        tracking: 'Facebook Landing Page'
    },
    VBC_LEARNING_PATH: {
        tracking: "VBC Learning Path Page",
        seo: "VBC Learning Path - EmploSkills Virtual Business Challenge"
    },
    HOME_ALT: {
        tracking: "Alternative Homepage",
        seo: "EmploSkills - Learn Business By Doing Business"
    },
    HOME_HOMESCHOOL: {
        tracking: "Homeschool Homepage",
        seo: "Virtual Business Challenge for Homeschoolers - EmploSkills"
    },
    VBC_ONLINE: {
        tracking: "VBC Online Live Classes Page",
        seo: "VBC Online - Live Business Classes for Homeschoolers | EmploSkills"
    },
}; 